const skills = [
  {
    category: "Front-end Development",
    items: [
      "Next js",
      "React js",
      "Javascript",
      "Typescript",
      "CSS Frameworks",
      "Tailwind",
      "Daisy UI",
      "Framer Motion",
      "Redux",
      "React Router",
      "Internationalization (i18n)",
      "PWA",
      "API Integrations",
    ],
  },
  {
    category: "Back-end Development",
    items: [
      "Node js",
      "Express js",
      "tRPC",
      "REST APIs",
      "FastAPI",
      "Python",
      "Next Auth",
      "AI Integrations",
      "Anthropic API",
      "Resend",
      "Postman",
    ],
  },
  {
    category: "ORMs",
    items: ["Prisma ORM", "Sequelize ORM"],
  },
  {
    category: "Mobile App Development",
    items: ["React Native", "Expo", "Firebase", "Dialogflow"],
  },
  {
    category: "Database",
    items: ["PostgreSQL", "MySQL", "Redis"],
  },
  {
    category: "Unit Test",
    items: ["Jest", "React Testing Library"],
  },
  {
    category: "Cloud Database and Hosting Platforms",
    items: [
      "AWS EC2",
      "AWS S3 Bucket",
      "AWS Amplify",
      "Azure",
      "Vercel",
      "Netlify",
      "Railway",
      "Cloudflare",
      "Neon",
      "Supabase",
    ],
  },
  {
    category: "CI/CD Pipelines",
    items: ["GitHub / Git"],
  },
  {
    category: "CMS & Website Builders",
    items: ["Wix"],
  },
  {
    category: "AI Assistant Tool",
    items: ["Claude Code"],
  },
];

export default skills;
